import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { WorkspaceComponent } from 'app/components/core/workspace/workspace.component';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ProductService } from 'services/product.service';

@Component({
	selector: 'delete-product-warning',
	templateUrl: './delete-product-warning.component.html',
	styleUrls: ['./delete-product-warning.component.scss'],
	imports: [Layout, NgClass, TranslatePipe]
})
export class DeleteProductWarningComponent {

	productId: string | undefined = '';
	productName: string | undefined = '';
	deletingProduct: boolean = false;
	constructor(private workspace: WorkspaceComponent, private readonly productService: ProductService) {
	}

	deleteProduct() {
		this.deletingProduct = true;
		if (this.productId) {
			this.productService.deleteProduct(this.productId).then(() => {
				this.workspace.closePopup();
			});
		}
	}

	close() {
		this.workspace.closePopup();
	}
}